const FAQ_ITEMS = [
  {
    q: '红桃影视需要付费或注册会员吗？',
    a: '完全不需要！红桃影视所有剧集都是免费观看的，无需注册、无需付费、无需开通会员。打开网站就能直接观看高清剧集，没有任何隐藏收费。',
  },
  {
    q: '剧集的画质怎么样？支持哪些清晰度？',
    a: '红桃影视所有剧集均提供1080P超清画质，部分热门剧集还支持4K。系统会根据您的网络状况智能匹配最佳码率，确保流畅播放。',
  },
  {
    q: '能在手机和平板上看吗？',
    a: '当然可以！红桃影视完美适配手机、平板和电脑等多种设备。在浏览器中打开即可观看，界面自动适配屏幕尺寸，躺着也能追剧。',
  },
  {
    q: '更新速度怎么样？新剧多久上线？',
    a: '我们与各大平台保持同步更新。热门大陆剧通常在播出后2小时内上线，韩剧在韩国播出后24小时内更新中文字幕版，追剧不等待。',
  },
  {
    q: '剧集资源有哪些类型？只限于国产剧吗？',
    a: '红桃影视涵盖大陆剧、韩剧、港剧、台剧、日剧、美剧等多种类型。无论你喜欢古装、悬疑、爱情还是都市题材，这里都能找到心仪的剧集。',
  },
  {
    q: '遇到播放问题或者有建议怎么办？',
    a: '您可以通过页面底部的联系方式或"联系我们"板块与我们沟通。我们非常重视用户反馈，通常会在24小时内回复处理您的建议和问题。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100/60 text-secondary-700 text-xs font-medium mb-4">
              答疑解惑
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              常见问题
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              关于红桃影视的常见疑问，这里都有详细解答
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
            {FAQ_ITEMS.map((item, i) => (
              <details key={i} className="group bg-background-100 rounded-xl border border-background-200/40 overflow-hidden cursor-pointer" open={i < 3}>
                <summary className="flex items-center justify-between px-5 md:px-6 py-4 md:py-5 list-none">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 pr-4">{item.q}</h3>
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 group-open:bg-primary-500 group-open:text-background-50 transition-colors">
                    <i className="ri-arrow-down-s-line text-sm group-open:rotate-180 transition-transform duration-200"></i>
                  </span>
                </summary>
                <div className="px-5 md:px-6 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}